import { MasterService } from './../../home/services/master.service';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";


@Component({
  selector: 'app-delete-modal',
  templateUrl: './delete-modal.component.html',
  styleUrls: ['./delete-modal.component.scss']
})
export class DeleteModalComponent implements OnInit {

  public selectedIndex: any;
  public bodyParts: any;
  public updateBodyParts: any;
  public recordToBeDeletedID: any;
  public recordToBeDeletedEnc_ID: any;
  public deleteUrl: any;
  public currentUrl: any;


  constructor(public dialogRef: MatDialogRef<DeleteModalComponent>, @Inject(MAT_DIALOG_DATA) data, public masterService: MasterService) {

    
    //this.selectedIndex = data.index;
    //this.bodyParts = data.bodyParts;
    //console.log(this.bodyParts, 'res');
    //console.log(this.bodyParts[this.selectedIndex]['id'], 'selected');
    //this.bodyParts[this.selectedIndex]
    this.recordToBeDeletedID = data['id'];
    this.recordToBeDeletedEnc_ID = data['encId'];
    this.deleteUrl = data['deleteUrl'];  
    

  }

  ngOnInit() {
  }



  deleteRecord() { 
    if (this.recordToBeDeletedID && this.recordToBeDeletedEnc_ID) {
      this.masterService.deleteRecord(this.recordToBeDeletedID, this.recordToBeDeletedEnc_ID, this.deleteUrl)
        .subscribe(res => {

          if (res['success']) {
            let e = 1;  
            this.close();
          }
        })
    }
  }

  close() {
    this.dialogRef.close();
  }

}
